import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ITrackingCode } from "@/services/DTOs";
import { OpportunitiesApiService } from "@/services/OpportunitiesApiService";
import { trackAPICall } from "@/services/SnowplowService";

class Service {
  @trackAPICall("POST", "TrackingCode", "utm", (args) => ({ campaign: args[0].campaign }))
  public addTrackingCode(code: ITrackingCode): Observable<string> {
    const url = "/api/suite/tracking-codes";

    return OpportunitiesApiService.post(url, code).pipe(map((response) => response.data.id));
  }

  @trackAPICall("POST", "TrackingCode", "bind", (args) => ({ entity: args[1] }))
  public bindTrackingCodeWithEntity(codeId: string, entity: "candidates" | "feedback", entityId: string): Observable<string> {
    const url = `/api/suite/tracking-codes/${codeId}/${entity}`;

    return OpportunitiesApiService.post(url, { entityId }).pipe(map((response) => response.data.id));
  }

}

export const TrackingCodeService = new Service();
